import "./styles.less";
import React from "react";

export const OfflineToastLoader = () => {

	return (
		<div className="flex">
			<div className="loader">{"Cargando..."}</div>
			<span style={{ marginLeft: "12px" }}>{"Sin conexión a Internet"}.</span>
		</div>
	);
};
